import { useAmp } from 'next/amp'
import Script from 'next/script'

const GTMWrapper = () => {
	const isAmp = useAmp()

	if (process.env.NODE_ENV !== 'production') {
		return null
	}

	return (
		<>
			{isAmp ? (
				<script
					async
					custom-element="amp-analytics"
					src="https://cdn.ampproject.org/v0/amp-analytics-0.1.js"
				></script>
			) : process.browser ? (
				<Script
					id="gtag-base"
					strategy="afterInteractive"
					dangerouslySetInnerHTML={{
						__html: `(function (w, d, s, l, i) {
									w[l] = w[l] || []; w[l].push({
									'gtm.start':
										new Date().getTime(), event: 'gtm.js'
									}); var f = d.getElementsByTagName(s)[0],
									j = d.createElement('script'), dl = l != 'dataLayer' ? '&l=' + l : ''; j.defer; j.src =
										'https://www.googletagmanager.com/gtm.js?id=' + i + dl; f.appendChild(j);
								})(window, document, 'body', 'dataLayer', 'GTM-PX5SGGD');`,
					}}
				/>
			) : null}
			{isAmp ? (
				<amp-analytics
					config="https://www.googletagmanager.com/amp.json?id=GTM-PX5SGGD"
					data-credentials="include"
				/>
			) : null}
		</>
	)
}

export default GTMWrapper
